import React from 'react';
import PropTypes from 'prop-types';
import { StaffMemberShape } from '../../global-constants';
import { useIsVertical } from '../../hooks/useIsVertical';

const StaffDetails = ({ staffMember, isWithinModal }) => {
	const isVertical = useIsVertical();

	return (
		<>
			{/* TODO: need to account for setting margin-top conditionally for <h3 /> */}
			<h3 className={`line-truncate ${isVertical ? 'mt-0' : ''}`}>
				{staffMember.name}
			</h3>
			<p className="line-truncate">{staffMember.title}</p>
			{!isWithinModal && <p>{staffMember.phone}</p>}
			{isWithinModal && staffMember?.bio && (
				<p style={{ whiteSpace: 'pre-wrap' }}>{staffMember?.bio}</p>
			)}
			{isWithinModal && <p>{staffMember.phone}</p>}
		</>
	);
};

StaffDetails.propTypes = {
	isWithinModal: PropTypes.bool,
	staffMember: PropTypes.shape(StaffMemberShape)
};

export default StaffDetails;
